<script>
  import TooltipHeader from './TooltipHeader.svelte';
  import StackedBar from './StackedBar.svelte';
  import PartyTable from './PartyTable.svelte';
  import { textOn } from '../utils/parties.js';

  /**
   * Tooltip card. The parent (Chart.svelte) decides what record to show
   * and where (x/y in container coordinates on desktop, bottom-sheet on
   * mobile). This component just composes the three inner blocks and
   * positions itself accordingly.
   */
  let {
    record = null,
    x = 0,
    y = 0,
    isMobile = false,
    pinned = false,
    partyColor,
    partyLongName,
    onClose
  } = $props();

  const visible = $derived(record != null);
  const bgColor = $derived(record ? partyColor(record.winner, record.winnerCode) : '#444');
  const textColor = $derived(textOn(bgColor));

  let tooltipEl = $state();

  // Desktop positioning: avoid overflowing the parent container.
  const style = $derived.by(() => {
    if (!record || isMobile) return null;
    const w = tooltipEl?.offsetWidth || 240;
    const h = tooltipEl?.offsetHeight || 160;
    const parent = tooltipEl?.offsetParent || document.body;
    const maxX = (parent?.clientWidth || 1000) - w - 8;
    const left = Math.min(Math.max(8, x + 14), Math.max(8, maxX));
    const top = Math.max(8, y - h - 12 < 8 ? y + 16 : y - h - 12);
    return `left:${left}px;top:${top}px;`;
  });
</script>

<div class="tooltip-anchor">
  <div
    bind:this={tooltipEl}
    class="tooltip"
    class:visible
    class:pinned
    role="tooltip"
    aria-hidden={!visible}
    style={style || ''}
  >
    <button
      type="button"
      class="close-btn"
      aria-label="Cerrar"
      style:color={textColor}
      onclick={onClose}
    >&times;</button>

    {#if record}
      <div class="tooltip-content">
        <TooltipHeader {record} {bgColor} {textColor} />
        <StackedBar topParties={record.topParties} {partyColor} />
        <PartyTable
          topParties={record.topParties}
          {partyColor}
          {partyLongName}
        />
      </div>
    {/if}
  </div>
</div>
